var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "timer_svg__a",
    x: -31.87,
    y: 0.135,
    width: 184.712,
    height: 185.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197_1736"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.021
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.19
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0287811 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_197_1736",
    result: "effect2_dropShadow_197_1736"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_197_1736",
    result: "effect3_dropShadow_197_1736"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_197_1736",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "timer_svg__currentLayer"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#timer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.52 3.402a10.089 10.089 0 012.8 2.834 10.683 10.683 0 011.545 3.756 93.6 93.6 0 01.205 35.953 10.382 10.382 0 01-1.495 3.717c-1.51 2.297-3.817 3.863-6.424 4.358a88.651 88.651 0 01-35.3-.131l.004-.01a10.096 10.096 0 01-3.67-1.553c-1.1-.74-2.051-1.705-2.797-2.838a10.717 10.717 0 01-1.543-3.756 93.672 93.672 0 01-.205-35.95 10.33 10.33 0 011.495-3.717c1.51-2.298 3.82-3.863 6.43-4.359a88.692 88.692 0 0135.293.136 10.09 10.09 0 013.663 1.56z",
    fill: "#F8D374"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.842 38.865c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "#DEA13A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.842 27.865l4.95-4.95M23.842 12.865h6",
    stroke: "#DEA13A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgTimer;